module.exports = __webpack_public_path__ + "assets/img/ban3.9a1c9b17.jpg";